import {launchDarkly} from 'utils/launchDarkly';

// swaps the classic Configuration -> Organisation chart, and the tree the organisation chart
// popup picks a unit from, for the ag-grid rendering (see NewOrganisationChart.component)
export const NEW_ORGANISATION_CHART_FLAG = 'fe-use-new-organisation-chart';

/**
 * Read at render by the page's own wrapper, so the page itself decides which of its two
 * renderings it is - rather than the route, or the popup, deciding for it.
 */
export const isNewOrganisationChartEnabled = (): boolean =>
    launchDarkly.userClient?.variation(NEW_ORGANISATION_CHART_FLAG, false) ?? false;
